var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag px-1 fs-5 rounded",class:_vm.componentClass},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }